// revenuecat.js
import { Purchases } from '@revenuecat/purchases-capacitor';
import { Capacitor } from '@capacitor/core';
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '@/main';

class RevenueCatService {
  constructor() {
    this.apiKey = "goog_PyeEqdeOjTnTzrWolIMCmmjgbuG"; 
    this.isInitialized = false;
  }

  // ------------------------------
  // Initialise RevenueCat et le listener
  async initialize(userId) {
    if (!Capacitor.isNativePlatform() || this.isInitialized) return;

    try {
      await Purchases.configure({
        apiKey: this.apiKey,
        appUserID: userId || null
      });
      this.isInitialized = true;
    //   alert('✅ RevenueCat initialisé avec succès');

      // Ajouter le listener pour mettre à jour Firestore et l'UI
      Purchases.addCustomerInfoUpdateListener(async (customerInfo) => {
        const isPremium = typeof customerInfo.entitlements.active['premium'] !== "undefined";
        this.isPremiumUser = isPremium;

        // Mise à jour Firestore automatiquement
        if (userId) {
          await this.updateUserPremiumStatus(userId, isPremium);
        }

        // Debug / alert pour tester
        // alert(`ℹ️ Statut premium mis à jour via listener : ${isPremium ? 'Premium' : 'Non Premium'}`);
      });

    } catch (error) {
      alert(`❌ Erè inisyalizasyon. Reyeseye aprè yon ti tan.`);
      throw error;
    }
  }

  // ------------------------------
  async updateUserPremiumStatus(userId, isPremium = true) {
    if (!userId) return false;

    try {
      const userRef = doc(db, 'users', userId);
      await updateDoc(userRef, {
        premium: isPremium,
        premiumActivatedAt: new Date(),
        subscriptionStatus: isPremium ? 'active' : 'inactive'
      });
    //   alert(`✅ Statut Itilizatè mis à jour: ${isPremium ? 'Premium' : 'Non Premium'}`);
      return true;
    } catch (error) {
    //   alert(`❌ Erreur mise à jour Firestore: ${error.message || error}`);
      return false;
    }
  }

  // ------------------------------
  async checkFirestorePremiumStatus(userId) {
    if (!userId) return false;
    
    try {
        const userRef = doc(db, 'users', userId);
        const userDoc = await getDoc(userRef);
        
        if (userDoc.exists()) {
            return userDoc.data().premium === true;
        }
        return false;
    } catch (error) {
        // alert(`❌ Erreur vérification Firestore: ${error.message || error}`);
        return false;
    }
  }

  // ------------------------------
  async checkPremiumStatus(userId) {
    const firestorePremium = await this.checkFirestorePremiumStatus(userId);
    let revenueCatPremium = false;

    try {
      const customerInfo = await Purchases.getCustomerInfo();
      revenueCatPremium = typeof customerInfo.entitlements.active['premium'] !== "undefined";
    } catch (err) {
    //   console.error('Erreur récupération RevenueCat:', err);
    }

    if (revenueCatPremium && !firestorePremium) {
      await this.updateUserPremiumStatus(userId, true);
    }

    return revenueCatPremium || firestorePremium;
  }
}

export default new RevenueCatService();
